module.exports = __webpack_public_path__ + "static/media/147.56b03cdc.jpg";